import { render, staticRenderFns } from "./newsDetails.vue?vue&type=template&id=48855e45&scoped=true&"
import script from "./newsDetails.vue?vue&type=script&lang=js&"
export * from "./newsDetails.vue?vue&type=script&lang=js&"
import style0 from "./newsDetails.vue?vue&type=style&index=0&id=48855e45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48855e45",
  null
  
)

export default component.exports